module.exports = angular.module('utility-ng-configuration').provider('Configuration', function ConfigurationNG() {

  var ConfigurationDef = function ConfigurationDef() {

    var internalConfiguration = {};
    var defaultConfiguration = {
      tracking: {},
      about: {
        member: '',
        application: '',
        subheader: '',
        version: {
          ui: '0.1.0',
          api: '1'
        }
      }
    };

    // settings to make templates in lodash work like angular
    const doNotAssignToLodash3 = {
      interpolate: /{{([\s\S]+?)}}/g
    };

    /**
     *
     */
    this.read = function readConfiguration(key) {
      return (!!key)
        ? internalConfiguration[key]
        : internalConfiguration;
    };

    /**
     *
     */
    this.write = function writeConfiguration(userConfig) {
      internalConfiguration = _.merge({}, defaultConfiguration, internalConfiguration, userConfig || {});
      return this;
    };

    /**
     *
     */
    this.overwrite = function overwriteConfiguration(userConfig) {
      internalConfiguration = _.merge({}, defaultConfiguration, userConfig || {});
      return this;
    };

  };

  var Configuration = new ConfigurationDef();

  this.write = function writeConfigurationProvider(userConfig) {
    Configuration.write(userConfig);
    return Configuration;
  };

  this.read = function readConfigurationProvider(key) {
    return Configuration.read(key);
  };

  this.request = function requestConfiguration() {
    return Configuration;
  };

  this.$get = function $getConfiguration() {
    return Configuration;
  };

});



// WEBPACK FOOTER //
// configuration.js